/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import './Footer.css'
import {FaFacebook} from 'react-icons/fa'
import {FaInstagram} from 'react-icons/fa'
import {FaGithub} from 'react-icons/fa'
import {FaTwitter} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>EMMANUEL</a>
      <ul className='permalinks'>
        <li><a href="#">HOME</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonial">Testimonials</a></li>
      </ul>
      <div className="footer__socials">
        <a href="https://facbook.com"><FaFacebook/></a>
        <a href="https://instagram.com/emman@gyimah"><FaInstagram/></a>
        <a href="https://twitter.com/RaidenKhanXMV"><FaTwitter/></a>
        <a href="https://github.com/raidenkhan"><FaGithub/></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; Emmanuel Gyimah</small>
      </div>
    </footer>
  )
}

export default Footer